import React from 'react';

/**
 * FilterChip Component
 * 
 * Reusable filter button/chip component.
 * Used in RightSidebar and ContlyRightSidebar for filtering documents.
 * 
 * @param {string} label - Filter label
 * @param {boolean} isActive - Whether filter is currently active
 * @param {function} onClick - Click handler
 * @param {string} theme - Theme ('dark' or 'light')
 */
const FilterChip = ({ label, isActive, onClick, theme = 'dark' }) => {
  const handleMouseEnter = (e) => {
    if (!isActive) {
      if (theme === 'dark') {
        e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.25)';
        e.currentTarget.style.color = 'rgba(255, 255, 255, 0.8)';
      } else {
        e.currentTarget.style.borderColor = 'rgba(100, 116, 139, 0.6)';
        e.currentTarget.style.background = 'rgba(255, 255, 255, 0.95)';
        e.currentTarget.style.color = '#0f172a';
        e.currentTarget.style.boxShadow = '0 2px 6px rgba(15, 23, 42, 0.12), 0 1px 3px rgba(0, 0, 0, 0.08)';
      }
    }
  };

  const handleMouseLeave = (e) => {
    if (!isActive) {
      if (theme === 'dark') {
        e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.15)';
        e.currentTarget.style.color = '#888888';
      } else {
        e.currentTarget.style.borderColor = 'rgba(71, 85, 105, 0.5)';
        e.currentTarget.style.background = 'rgba(255, 255, 255, 0.9)';
        e.currentTarget.style.color = '#1e293b';
        e.currentTarget.style.boxShadow = '0 1px 3px rgba(15, 23, 42, 0.08), 0 0 1px rgba(0, 0, 0, 0.05)';
      }
    }
  };

  return (
    <button
      type="button"
      onClick={onClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className="filter-chip px-[14px] py-1.5 rounded-full text-[11px] font-medium transition-all duration-300 cursor-pointer border bg-transparent font-inherit uppercase tracking-wider"
      style={{
        border: isActive
          ? theme === 'dark'
            ? '0.5px solid rgba(255, 255, 255, 0.8)'
            : '0.5px solid rgba(51, 65, 85, 0.7)'
          : theme === 'dark'
          ? '0.5px solid rgba(255, 255, 255, 0.15)'
          : '0.5px solid rgba(71, 85, 105, 0.5)',
        background: isActive
          ? theme === 'light'
            ? 'rgba(255, 255, 255, 0.98)'
            : 'transparent'
          : theme === 'light'
          ? 'rgba(255, 255, 255, 0.9)'
          : 'transparent',
        backdropFilter: theme === 'light' ? 'blur(20px)' : 'none',
        WebkitBackdropFilter: theme === 'light' ? 'blur(20px)' : 'none',
        color: isActive
          ? theme === 'dark' ? '#ffffff' : '#0f172a'
          : theme === 'dark' ? '#888888' : '#1e293b',
        boxShadow: isActive
          ? theme === 'dark'
            ? '0 0 10px rgba(255, 255, 255, 0.2)'
            : '0 2px 8px rgba(15, 23, 42, 0.15), 0 1px 3px rgba(0, 0, 0, 0.1)'
          : theme === 'light'
          ? '0 1px 3px rgba(15, 23, 42, 0.08), 0 0 1px rgba(0, 0, 0, 0.05)'
          : 'none',
      }}
    >
      {label}
    </button>
  );
};

export default FilterChip;

